module.exports = __webpack_public_path__ + "img/caseBg.4769d337.png";